import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function LibraryBooksPage() {
  return <InstituteCrudPage config={entityConfigs['library-books']} />;
}
